import React from "react";
import "./About.css";

const About = () => {
  return (
    <section className="about">
      <h1 className="about__heading">About Us</h1>
      <p className="about__desc">
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorum iusto
        inventore, voluptatem eveniet pariatur tempora! Ex animi in omnis
        perspiciatis ducimus id nostrum voluptatum. Voluptatem ducimus non,
        quaerat vel repudiandae iure, ab minus odit ex sunt architecto fugiat at
        reprehenderit ipsam quasi doloremque ratione quod voluptates dicta eos
        sit cum eius! Amet, nihil ipsa. Dolore asperiores fuga dicta magni at!
        Quam reprehenderit tempore dolore dolorem voluptates dolores cum atque
        eius, optio, quidem reiciendis ullam molestiae rem nesciunt incidunt
        soluta beatae dolorum cupiditate enim quibusdam. Dolorem, aspernatur
        quia architecto dicta praesentium eum! Iste, nam amet earum esse
        exercitationem numquam, quia consectetur dicta officia odit voluptatibus
        cupiditate sapiente mollitia soluta provident. Quae, expedita ipsa
        deserunt laboriosam culpa sapiente nobis ratione maiores, officia fuga
        asperiores sed eos magni blanditiis similique. Temporibus beatae tempora
        autem iste, ipsam amet blanditiis maxime voluptatum. Veniam, corporis
        itaque excepturi tempora eaque, incidunt accusantium libero iusto
        officiis odit hic. Ullam sequi, cumque nemo blanditiis maiores facere
        enim ratione sed quod ab iste dolore dolorum. Voluptatum dolor explicabo
        eum inventore odit quaerat sed eveniet, optio quam voluptatem dolorem
        veniam debitis quas fuga, nisi eligendi saepe? Tempora deserunt quia ea
        repellendus nobis impedit quasi qui dolores nostrum? Ut dicta omnis quis
        sed corrupti beatae totam quas ad, cupiditate rerum aspernatur incidunt,
        accusamus tempora quasi, perferendis maiores assumenda! Dicta nam ab
        dolor recusandae corrupti doloribus a in obcaecati, eligendi tenetur
        velit necessitatibus repudiandae voluptatum? Facere consequatur eum sit
        molestiae beatae similique perspiciatis libero maiores ducimus vitae,
        explicabo eaque velit voluptatem quo mollitia!
      </p>
    </section>
  );
};

export default About;
